/**
 * 商品ページ（v2）の処理
 */
(function () {
  "use strict";

  // 定数
  const SELECTORS = {
    comparisonChart: "#products-comparison-chart-content",
    readMore: "#products-comparison-chart-readmore",
    splideProducts: ".js-splide_products",
    reviewRating: ".star-ratings-css",
    reviewRatingText: ".mxpr-summary__count",
    productReviewRating: ".product-review-rating-stars",
    productReviewRatingText: ".product-review-rating-text",
    linkShare: "#link-share",
    faqQuestions: ".product-specs-faq h2",
    quantityInput: "[data-quantity-input]",
    quantityInputSticky: "[data-quantity-input-sticky]",
    productSummary: ".product-summary",
    productSummaryButton: ".product-summary__show-more",
    stickyBtnBlock: ".product-form-btn-block--sticky",
    productFeaturedInfo: "#productFeaturedInfoSection",
  };

  const SPLIDE_CONFIG = {
    autoplay: false,
    type: "slide",
    pagination: false,
    arrows: true,
    interval: 1000,
    speed: 300,
    fixedWidth: 255,
    perPage: 1,
    drag: true,
    start: 0,
    breakpoints: {
      1080: {
        autoWidth: true,
        gap: 0,
        arrows: false,
      },
    },
  };

  const MOBILE_BREAKPOINT = 769;
  const FAQ_HEIGHT_LIMIT = 5;

  /**
   * 比較チャートの「もっと見る」機能
   */
  const setReadmore = () => {
    const tableDom = document.querySelector(SELECTORS.comparisonChart);
    const readMore = document.querySelector(SELECTORS.readMore);

    if (!readMore || !tableDom) return;

    readMore.addEventListener("click", () => {
      tableDom.classList.add("is-open");
      readMore.classList.add("is-hide");
    });
  };

  /**
   * Splideスライダーの遅延初期化（ビューポートに入った時に初期化）
   */
  const setSplide = () => {
    const elements = document.querySelectorAll(SELECTORS.splideProducts);
    if (!elements.length || (typeof Splide === "undefined" && !window.V2Rail)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var scrollY = window.scrollY;
            v2Splide(entry.target, SPLIDE_CONFIG).mount();
            if (Math.abs(window.scrollY - scrollY) > 1) {
              window.scrollTo(0, scrollY);
            }
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "200px" },
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  };

  /**
   * レビュー評価の表示はサーバ描画（product-review-rating.liquid）を恒久利用する。
   * アプリ(mxpr)の .star-ratings-css は★を整数（5段階）に丸めるため、平均4.9でも
   * ★★★★☆と過小表示されてしまう。サーバ描画は star-rating-fill を
   * width:(stars/5*100)% の連続塗りで描くため小数第一位まで正確に表現できる
   * （メタフィールド prime_review.summary.stars が信頼ソース）。
   * よってアプリ版★での上書き（旧 cloneReviewRating）は廃止した。
   * 2026-06: レビュー★が過小評価される問題の修正（Option1: 連続塗りで小数表現）。
   */

  /**
   * リンクシェア機能
   */
  const setLinkShareEvent = () => {
    const shareLink = document.querySelector(SELECTORS.linkShare);
    if (!shareLink) return;

    shareLink.addEventListener("click", async (e) => {
      e.preventDefault();
      try {
        await navigator.share({
          title: document.title,
          url: location.href,
        });
      } catch (error) {
        // ユーザーがキャンセルした場合などはエラーを無視
        if (error.name !== "AbortError") {
          console.error("Share failed:", error);
        }
      }
    });
  };

  /**
   * FAQの開閉機能
   */
  /**
   * FAQの開閉機能 (Event Delegation)
   */
  const setFaqEvent = () => {
    const faqContainer = document.querySelector(".product-specs-faq");
    if (!faqContainer) return;

    const questions = faqContainer.querySelectorAll("h2");
    if (questions.length > 0) {
      // 最初の質問を開いた状態にする
      questions[0].classList.add("active");
      const firstAnswer = questions[0].nextElementSibling;
      if (firstAnswer) {
        firstAnswer.classList.add("active");
      }
    }

    faqContainer.addEventListener("click", (e) => {
      const question = e.target.closest("h2");
      if (!question) return;

      const answer = question.nextElementSibling;
      if (answer) {
        question.classList.toggle("active");
        answer.classList.toggle("active");
      }
    });
  };

  /**
   * 数量入力の同期
   */
  const syncQuantityInputs = () => {
    const quantityInput = document.querySelector(SELECTORS.quantityInput);
    const quantityInputSticky = document.querySelector(
      SELECTORS.quantityInputSticky,
    );

    if (!quantityInput || !quantityInputSticky) return;

    const syncToSticky = (e) => {
      quantityInputSticky.value = e.target.value;
    };

    const syncToMain = (e) => {
      quantityInput.value = e.target.value;
    };

    quantityInput.addEventListener("change", syncToSticky);
    quantityInputSticky.addEventListener("change", syncToMain);
  };

  /**
   * 商品コメントの「もっと見る」機能
   */
  const setProductComments = () => {
    const content = document.querySelector(SELECTORS.productSummary);
    const button = document.querySelector(SELECTORS.productSummaryButton);

    if (!content || !button) return;

    const h3Elements = content.querySelectorAll("h3");
    if (h3Elements.length < 4) return;

    let heightLimit = 0;
    for (let i = 0; i < Math.min(h3Elements.length, FAQ_HEIGHT_LIMIT); i++) {
      const h3 = h3Elements[i];
      heightLimit += h3.offsetHeight;
      const nextEl = h3.nextElementSibling;
      if (nextEl) {
        heightLimit += nextEl.offsetHeight;
      }
    }

    content.style.maxHeight = `${heightLimit}px`;
    content.style.overflow = "hidden";
    button.style.display = "block";

    button.addEventListener("click", () => {
      const isExpanded = content.style.maxHeight !== `${heightLimit}px`;
      button.style.display = "none";

      if (isExpanded) {
        content.style.maxHeight = `${heightLimit}px`;
      } else {
        // scrollHeightはリフローを引き起こすが、クリック時のみなので許容
        content.style.maxHeight = `${content.scrollHeight}px`;
      }
    });
  };

  /**
   * PhotoSwipeライトボックスの初期化
   */
  const initializePhotoSwipe = () => {
    try {
      const lightbox = new PhotoSwipeLightbox({
        gallery: "#gallery",
        children: "a",
        pswpModule: PhotoSwipe,
        padding: { top: 20, bottom: 20, left: 20, right: 20 },
      });
      lightbox.init();
    } catch (error) {
      console.error("PhotoSwipe initialization failed:", error);
    }
  };

  /**
   * スティッキーボタンブロックの表示制御
   */
  const setStickyBtnBlockVisibility = () => {
    const stickyBlock = document.querySelector(SELECTORS.stickyBtnBlock);
    const productFeaturedInfoSection = document.querySelector(
      SELECTORS.productFeaturedInfo,
    );

    if (!stickyBlock || !productFeaturedInfoSection) return;

    let triggerTop = 0;
    let isMobile = false;

    const updateMetrics = () => {
      isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
      if (isMobile) {
        // getBoundingClientRect + scrollY はリフローを引き起こすので、リサイズ時のみ計算
        triggerTop =
          productFeaturedInfoSection.getBoundingClientRect().top +
          window.scrollY;
      }
    };

    const toggleStickyBtnBlock = () => {
      if (isMobile) {
        stickyBlock.style.display =
          window.scrollY >= triggerTop ? "flex" : "none";
      } else {
        stickyBlock.style.display = "";
      }
    };

    // 初期計算
    updateMetrics();
    toggleStickyBtnBlock();

    // パフォーマンス最適化: throttleを使用
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          toggleStickyBtnBlock();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    // リサイズ時はメトリクスを再計算してから表示更新
    let resizeTimer;
    window.addEventListener(
      "resize",
      () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          updateMetrics();
          toggleStickyBtnBlock();
        }, 200);
      },
      { passive: true },
    );
  };

  /**
   * 初期化処理
   */
  const initialize = () => {
    setReadmore();
    setSplide();
    setLinkShareEvent();
    setFaqEvent();
    syncQuantityInputs();
    initializePhotoSwipe();
    setProductComments();
    setStickyBtnBlockVisibility();
  };

  document.addEventListener("DOMContentLoaded", initialize);
})();
